function handleHeaderSearchSubmit(event) {
  event.preventDefault();
  const form = event.target;
  const searchInput = form.querySelector('input[type="search"]');
  const searchTerm = searchInput.value;
  
  // Remove all spaces from the search term
  const cleanSearchTerm = searchTerm.replace(/\s+/g, '');
  
  // Update the input value with the space-free search term
  searchInput.value = cleanSearchTerm;
  
  // Only submit if there's actual content after removing spaces
  if (cleanSearchTerm) {
    form.submit();
  }
}

// Add event listener after DOM is fully loaded
document.addEventListener('DOMContentLoaded', function() {
  const searchForms = document.querySelectorAll('.search-modal__form');
  searchForms.forEach(form => {
    form.addEventListener('submit', handleHeaderSearchSubmit);
  });
});

